import { useQuery } from '@tanstack/react-query'

import { api } from '@/routes/shared/_api'

import { gtkyResponseSchema, GTKYResponseTypes } from './schema'

export const getGTKY = async () => {
  const response = await api.get('/dashboard/profile/gtky')
  return gtkyResponseSchema.parse(response)
}

export const useGTKY = (enabled = true) => {
  return useQuery<GTKYResponseTypes>({
    queryKey: ['gtky'],
    queryFn: getGTKY,
    enabled,
    staleTime: Infinity,
  })
}
